import z from 'zod';

import { HandoffReferencesSchema } from '@polyai/stream/commands/handlers/handoff/schema';
import {
  SipConfigSchema,
  SipHeadersSchema,
} from '@polyai/stream/commands/handlers/handoff/shared';

export const UpdateHandoffSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1).optional(),
  description: z.string().optional(),
  sipConfig: SipConfigSchema.optional(),
  sipHeaders: SipHeadersSchema.optional(),
  active: z.boolean().optional(),
  references: HandoffReferencesSchema.optional(),
});

export type UpdateHandoffPayload = z.infer<typeof UpdateHandoffSchema>;
